import { Tabbar } from '@systemeio/components'

interface TabsItem<T extends Tabbar.Tab.Value> {
  hasError?: boolean
  id: T
  overflowLabel?: string
  title: Tabbar.Item['children']
}

export interface TabsProps<T extends Tabbar.Tab.Value> {
  onSelect: (tabId: T) => void
  selectedTabId: T
  tabs: TabsItem<T>[]
}

export function Tabs<T extends Tabbar.Tab.Value>({ onSelect, selectedTabId, tabs }: TabsProps<T>) {
  return (
    <Tabbar
      onValueChange={value => onSelect(value as T)}
      tabs={tabs.map(({ hasError, id, overflowLabel, title }) => ({
        children: title,
        hasError,
        overflowLabel,
        value: id,
      }))}
      value={selectedTabId}
    />
  )
}
